<template>
	<template-base>
		<div class="container mt-4 border-top pt-2" v-bind:class="isMobile ? '' : 'relative'">
			<div v-bind:class="isMobile ? 'mb-2' : 'align-bottom-right'">
				<img style="width: 14rem" :src="logo"/>
			</div>
			<div class="mr-4">
				<h5>- Informações de registro do sistema</h5>
				<h6 class="ml-4">Usuário: {{ user }}</h6>
				<h6 class="ml-4">Válido até: {{ expiredDate }}</h6>
				<h6 class="ml-4">E-mail: {{ email }}</h6>
			</div>
		</div>
		<div class="container mt-4 pt-2 w-100 relative">
			<div class="border-top w-100 pt-2 border-bottom pb-4">
				<h5>- Informações para contato e suporte</h5>
				<div class="ml-4">
					<h5>Informática SG</h5>
					<h6>Celular: (66) 99933-1539</h6>
					<h6>E-mail: informaticasgcv@gmail.com</h6>
				</div>
				<div v-if="btnRenew" v-bind:class="isMobile ? 'mt-4 center w-100' : 'align-bottom-right mb-4 mr-1'">
					<button class="btn btn-primary" style="font-weight: 600;" @click="renewSubscription()">
						Renovar Assinatura
					</button>
				</div>
			</div>
		</div>
	</template-base>
</template>

<style scoped>
	.w-15 {
		width: 13.5rem;
	}

	.border-top {
		border-top: 1px solid rgb(179, 176, 176) !important;
	}

	.border-bottom {
		border-bottom: 1px solid rgb(179, 176, 176) !important;
	}

	.relative {
		display: flex;
		position: relative;
		width: 100%;
	}

	.align-bottom-right {
		position: absolute;
		bottom: 0px;
		right: 10px;
	}

	.space-between {
		display: flex;
		justify-content: space-between;
	}

	.center {
		display: flex;
		justify-content: center;
	}

	.w-100 {
		width: 100%;
	}
</style>

<script>
	import TemplateBase from "../templates/Base";
	import { formatterSimple, numberFormatted } from "../helpers/common";

	export default {
		components: { TemplateBase },

		data () {
			return {
				expiredDate: null,
				user: null,
				logo: null,
				email: null,
				btnRenew: null,
				isMobile: false
			};
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);

			const subscriptionData = localStorage.params ? (JSON.parse(localStorage.params))?.subscription : {};
			const profileUserConfig = localStorage.params ? JSON.parse(localStorage.params) : {};
			this.user = profileUserConfig.nomeUsuarioCompleto;
			this.email = profileUserConfig.email;
			this.expiredDate = subscriptionData.nextPayDate ? formatterSimple(new Date(subscriptionData.nextPayDate)) : "Licença vitalícia";
			this.btnRenew = Boolean(profileUserConfig?.subscription?.nextPayDate);
			this.logo = profileUserConfig.logo || null;
		},

		methods: {
			renewSubscription () {
				this.$router.push("/renovar");
			},

			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			}
		}
	};
</script>